import { render, staticRenderFns } from "./RecebimentoItemInfoSituacaoMultipla.vue?vue&type=template&id=62ed67a0&scoped=true"
import script from "./RecebimentoItemInfoSituacaoMultipla.vue?vue&type=script&lang=ts"
export * from "./RecebimentoItemInfoSituacaoMultipla.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ed67a0",
  null
  
)

export default component.exports